import moment from 'moment';
import { createContext, useState } from 'react';

// ----------------------------------------------------------------------

const initialState = {
  selectedDate: moment(),
  selectedDays: [],
  selectedSpecificDay: null,
  licenseCode: null,
  isChangedForm: false,
  appSetting: {},
};

const ReduxContext = createContext({
  ...initialState,
  setSelectedDate: () => Promise.resolve(),
  setSelectedDays: () => Promise.resolve(),
  setSelectedSpecificDay: () => Promise.resolve(),
  setLicenseCode: () => Promise.resolve(),
  setChangedForm: () => Promise.resolve(),
  setAppSetting: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

function ReduxProvider({ children }) {
  const [state, setState] = useState(initialState);

  const setSelectedDate = (date) => {
    setState(prevState =>({ ...prevState, selectedDate: date, selectedSpecificDay: null }));
  };

  const setSelectedDays = (days) => {
    setState(prevState =>({ ...prevState, selectedDays: days }));
  };

  const setSelectedSpecificDay = (day) => {
    setState(prevState =>({ ...prevState, selectedSpecificDay: day }));
  };

  const setLicenseCode = (code) => {
     setState(prevState =>({ ...prevState, licenseCode: code }));
  };

  const setChangedForm = (newState) => {
    setState(prevState =>({ ...prevState, isChangedForm: newState }));
  };

  const setAppSetting = (newState) => {
    setState(prevState =>({ ...prevState, appSetting: { ...state.appSetting, ...newState } }));
  };

  return (
    <ReduxContext.Provider
      value={{
        ...state,
        setSelectedDate,
        setSelectedDays,
        setSelectedSpecificDay,
        setLicenseCode,
        setChangedForm,
        setAppSetting,
      }}
    >
      {children}
    </ReduxContext.Provider>
  );
}

export { ReduxProvider, ReduxContext };
